module.exports = __webpack_public_path__ + "static/media/info-icon.0b5f9eb9.svg";